import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { AnalysisMetricTypes, Guid, State } from '../../models';

export function useDealGeographiesQuery(guid: Guid | undefined, metricType: AnalysisMetricTypes) {
	const api = useApi();

	return useQuery(
		QueryKeys.Geographies(guid, metricType),
		() => AxiosUtils.getResponseData<State[]>(api.get(CerebroApiEndpoints.DealGeographies(guid, metricType))),
		{ enabled: guid !== undefined }
	);
}
